import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

// Vue.prototype.$STATUS = [
//   { key: 1, name: '問合せ' },
//   { key: 2, name: '保護者面談' },
//   { key: 3, name: '体験授業' },
//   { key: 4, name: '提案' },
//   { key: 5, name: '入塾' },
//   { key: 6, name: '在籍' },
//   { key: 7, name: '退塾' },
//   { key: 8, name: '逸失' }
// ]

// Vue.prototype.$ACTIONS = [
//   { key: 1, name: 'DTS' }, // 9
//   { key: 2, name: '生徒面談' }, // 10
//   { key: 3, name: '保護者面談' }, // 11
//   { key: 4, name: 'YCS' }, // 12
//   { key: 5, name: '約束' }, // 13
//   { key: 6, name: '退塾' }, // 14
//   { key: 7, name: 'その他' } // 15
// ]

export default {
  namespaced: true,
  state () {
    return {
      metrics: [],
      reference: null
    }
  },
  getters: {
    metrics (state) {
      return state.metrics
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state, payload) {
      state.metrics = payload
    },
    add (state, payload) {
      state.metrics.push(payload)
    },
    update (state, payload) {
      const index = state.metrics.findIndex(metric => metric.key === payload.key)
      if (index !== -1) {
        Vue.set(state.metrics, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.metrics.findIndex(metric => metric.key === payload.key)
      if (index !== -1) {
        state.metrics.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('metrics_status')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['metricsStatus/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = null
        if (payload.key) {
          ref = db.collection('metrics_status').doc(payload.key)
        } else {
          ref = db.collection('metrics_status').doc()
          payload.key = ref.id
        }
        ref.set(payload)
          .then(function () {
            // const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
            // pause(0).then(() => {
            //   console.log('Document successfully written!')
            resolve()
            // })
          })
          .catch(function (error) {
            if (error) {
              // console.error('Error writing document: ', error)
            }
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('metrics_status').doc(payload).delete().then(function () {
          // console.log('Document successfully deleted!')
          resolve()
        }).catch(function (error) {
          if (error) {
            // console.error('Error removing document: ', error)
          }
          resolve()
        })
      })
    }
  }
}
